import { CALL_API } from '../middleware';
import {
  GET_DASHBOARD_REPORT,
  GET_DASHBOARD_REPORT_SUCCESS,
  GET_ONBOARDING_REPORT,
  GET_ONBOARDING_REPORT_SUCCESS,
  GET_REPORT_SELECTION_SUCCESS,
  CLIENTL3L4_CONFIG_SUCCESS,
  CLIENTL3L4_CONFIG_DATA,
} from '../types/investorReports';

import { AcountIDBasedonClientIDResponse, ClientL3L4_ConfigResponse } from '../types/api-types';

export const getInvestorReports =
  (body: any) =>
    async (dispatch: any): Promise<any> => {
      if (body.reportName != "ComprehensivePortfolio") {
        body = { ...body, level: 'Individual', }
      }
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/reports/generateInvestorReports`,
          method: 'POST',
          types: [GET_ONBOARDING_REPORT, GET_ONBOARDING_REPORT_SUCCESS],
          body: {
            ...body,
          },
        },
      });
    };

export const getInvestorReportsLevel =
  (body: any) =>
    async (dispatch: any): Promise<any> => {
      body = { ...body }
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/reports/generateInvestorReports`,
          method: 'POST',
          types: [GET_ONBOARDING_REPORT, GET_ONBOARDING_REPORT_SUCCESS],
          body: {
            ...body,
          },
        },
      });
    };

export const getClientL3L4_Config =
  (body: any) =>
    async (dispatch: any): Promise<ClientL3L4_ConfigResponse> => {
      body = { ...body }
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/reports/getClientL3L4_Config`,
          method: 'POST',
          types: [CLIENTL3L4_CONFIG_SUCCESS, CLIENTL3L4_CONFIG_DATA],
          body: {
            ...body,
          },
        },
      });
    };

export const getAcountIDBasedonClientID =
  (body: any) =>
    async (dispatch: any): Promise<AcountIDBasedonClientIDResponse> => {
      body = { ...body }
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/reports/GetAcountIDBasedonClientID`,
          method: 'POST',
          types: [CLIENTL3L4_CONFIG_SUCCESS, CLIENTL3L4_CONFIG_DATA],
          body: {
            ...body,
          },
        },
      });
    };

export const getDashboardReports =
  (body: any) =>
    async (dispatch: any): Promise<any> => {
      console.log("hello console")
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/reports/generateInvestorReports`,
          method: 'POST',
          types: [GET_DASHBOARD_REPORT, GET_DASHBOARD_REPORT_SUCCESS],
          body: {
            ...body,

          },
        },
      });
    };

export const getReportSelectionList =
  () =>
    async (dispatch: any): Promise<any[]> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/reports/getReportList`,
          method: 'GET',
          types: [GET_REPORT_SELECTION_SUCCESS, GET_REPORT_SELECTION_SUCCESS],
        },
      });
    };
